import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { ApiError } from '@root/globalTypes';
import { PourDropdownRespSuccess } from '../types';
import { useAppContext } from '@contexts/app';

export const usePourElementsDropdown = () => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const { data, error, isPending } = useQuery<PourDropdownRespSuccess, ApiError>({
    queryKey: queryKeys.dropdowns.pourElements,
    queryFn: () => queryFetch({ url: 'dropdowns/concrete_direct_pour_elements' }),
    placeholderData: (previousData) => previousData as PourDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
